<template>
    <div>
        <notifications :show="['all']"></notifications>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="box-layout-inner">
                <div class="account-section-links">


                    <router-link class="acc-inner-link" :to="{ name: 'account.bookings' }">
                        <div class="vhboth">
                            <i class="fa fa-ticket">
                            </i>

                            <span class="title">{{ locale.button_list_bookings }}</span>
                        </div>
                    </router-link>

                    <a class="acc-inner-link" @click="newBooking">
                        <div class="vhboth">
                            <i class="fa fa-ticket">
                                <span class="fa fa-plus"></span>
                            </i>

                            <span class="title">{{ locale.button_new_booking }}</span>
                        </div>
                    </a>

                    <router-link class="acc-inner-link" :to="{ name: 'account.membership' }">
                        <div class="vhboth">
                            <i class="fa fa-credit-card-alt">
                            </i>

                            <span class="title">{{ locale.button_membership_card }}</span>
                        </div>
                    </router-link>

                    <router-link class="acc-inner-link" :to="{ name: 'account.payments' }">
                        <div class="vhboth">
                            <i class="fa fa-gbp">
                            </i>

                            <span class="title">{{ locale.button_list_payments }}</span>
                        </div>
                    </router-link>

                    <router-link class="acc-inner-link" :to="{ name: 'account.children' }">
                        <div class="vhboth">
                            <i class="fa fa-child">
                            </i>

                            <span class="title">{{ locale.button_list_children }}</span>
                        </div>
                    </router-link>

                    <router-link class="acc-inner-link" :to="{ name: 'account.details' }">
                        <div class="vhboth">
                            <i class="fa fa-cog">
                            </i>

                            <span class="title">{{ locale.button_update_account_details }}</span>
                        </div>
                    </router-link>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            newBooking: function () {
                axios.post('/camp-booking/bookings', {
                    user_id: this.$root.auth.user_id
                }).then(response => {
                    this.$root.setBookingId();
                    this.$root.updateBasketCount();
                    if(this.$root.builder.hasOwnProperty('venue') && this.$root.builder.venue.id)
                        this.$router.push({ name: 'booking.age' });
                    else
                        window.location.replace(window.venues_change_url)
                }).catch(error => {
                    return false;
                })
                //
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.account;
            }
        },
        components: {
            'notifications': require('./Notifications.vue')
        },
        created () {
            /**Checking if the user is currently logged in**/
            axios.get('/camp-booking/users/current')
                .then(response => {
                    if(response.data.data.user_id == null) {
                        this.$router.push({name: 'auth.login'});
                        return false;
                    }
                })

            /**
             * Setting the headers
             */
            this.$root.headers = {
                title: this.$root.locale.miscellaneous.page_headings.account.overview
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Overview.vue?7223f45e